import { writable } from 'svelte/store';
export let vse = writable('');
export let id = writable('');
export let format = writable('inlined');
export let depth = writable('all');
export let hub = writable('');
export let locale = writable('');
